import { Heading } from 'components/v2/Typography/Heading';
import { themes } from 'kb-shared';
import styled from 'styled-components';

import { MobileProps } from './AuthFlowLayout.types';

export const FormContent = styled.div<MobileProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  width: 100%;
  box-sizing: content-box;
  padding-left: ${({ $mobile }) => ($mobile ? '0px' : '60px')};
  padding-right: ${({ $mobile }) => ($mobile ? '0px' : '60px')};
`;

export const Content = styled.div<MobileProps>`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 0px;
  flex-direction: ${({ $mobile }) => ($mobile ? 'column' : 'row')};
  align-items: ${({ $mobile }) => ($mobile ? 'center' : 'flex-start')};
`;

export const LeftContent = styled.div`
  flex: 3;
  @media ${themes.queries.mobile} {
    width: 100%;
  }
`;

export const RightContent = styled.div`
  flex: 1;
`;

export const TitleContainer = styled.div<MobileProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: 18px;
  flex-direction: ${({ $mobile }) => ($mobile ? 'column' : 'row')};
  margin-top: 30px;
`;

export const PageTitle = styled(Heading).attrs({ tag: 'h2', styledAs: 'h2' })`
  padding: 16px 0;
  justify-content: center;
  text-align: center;
`;

export const ContentContainer = styled.div`
  ${({ theme }) => theme.grid.pageContainer};
  flex: 1;
  padding-top: 40px;
  background: white;
  @media ${({ theme }) => theme.queries.minLargeDesktop} {
    padding-bottom: 96px;
  }
`;

export const FormContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
`;
